"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13799],{

/***/ 13799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ specialMonitoring; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/constants/contents/special-monitoring.ts
var SESSION_A = [
    {
        session: 1,
        orderCollection: "09:00 - 09:55",
        randomClosing: "09:53 - 09:55",
        orderMatching: "09:55 - 10:00"
    },
    {
        session: 2,
        orderCollection: "10:00 - 10:55",
        randomClosing: "10:53 - 10:55",
        orderMatching: "10:55 - 11:00"
    },
    {
        session: 3,
        orderCollection: "11:00 - 11:55",
        randomClosing: "11:53 - 11:55",
        orderMatching: "11:55 - 12:00"
    },
    {
        session: 4,
        orderCollection: "14:00 - 14:55",
        randomClosing: "14:53 - 14:55",
        orderMatching: "14:55 - 15:00"
    },
    {
        session: 5,
        orderCollection: "15:00 - 15:55",
        randomClosing: "15:53 - 15:55",
        orderMatching: "15:55 - 16:00"
    }, 
];
var SESSION_B = [
    {
        session: 1,
        orderCollection: "09:00 - 09:55",
        randomClosing: "09:53 - 09:55",
        orderMatching: "09:55 - 10:00"
    },
    {
        session: 2,
        orderCollection: "10:00 - 11:25",
        randomClosing: "11:23 - 11:25",
        orderMatching: "11:25 - 11:30"
    },
    {
        session: 3,
        orderCollection: "14:00 - 14:55",
        randomClosing: "14:53 - 14:55",
        orderMatching: "14:55 - 15:00"
    },
    {
        session: 4,
        orderCollection: "15:00 - 15:55",
        randomClosing: "15:53 - 15:55",
        orderMatching: "15:55 - 16:00"
    }, 
];
var CRITERIA = [
    {
        id: 1,
        content: "Harga rata-rata saham selama enam bulan terakhir di pasar reguler kurang dari Rp51. Kriteria ini tidak berlaku untuk perusahaan tercatat yang ada di papan akselerasi."
    },
    {
        id: 2,
        content: "Laporan keuangan auditan terakhir perusahaan terdapat disclaimer. Dengan aturan ini, bursa tidak perlu menunggu perusahaan tercatat mendapat opini disclaimer dua kali, tetapi bursa bisa langsung memasukkan perusahaan ke dalam pemantauan khusus."
    },
    {
        id: 3,
        content: "Memiliki ekuitas negatif pada laporan keuangan terakhir. Pada saat ini, bursa tidak menunggu laporan keuangan tahunan, tapi berdasarkan laporan keuangan interim per Maret, Juni, atau September."
    },
    {
        id: 4,
        content: "Memiliki anak perusahaan yang kontribusi pendapatannya material bagi perusahaan tercatat, dan juga anak perusahaan tersebut dalam kondisi dimohonkan PKPU atau pailit."
    }, 
];
var SPECIAL_INFO = {
    date: "25 Maret 2024",
    auction: "Full Call Auction"
};
var SESSION_A_EXISTING = [
    {
        session: "I",
        orderCollection: "09.00 - 11.55 WIB",
        processingOrder: "11.55 - 12.00 WIB"
    },
    {
        session: "II",
        orderCollection: "13.25 - 15.55 WIB",
        processingOrder: "15.55 - 16.00 WIB"
    }, 
];
var SESSION_B_EXISTING = [
    {
        session: "I",
        orderCollection: "09.00 - 11.25 WIB",
        processingOrder: "11.25 - 11.30 WIB"
    },
    {
        session: "II",
        orderCollection: "13.55 - 15.55 WIB",
        processingOrder: "15.55 - 16.00 WIB"
    }, 
];
var SPECIAL_INFO_EXISTING = {
    date: "12 Juni 2023",
    auction: "Hybrid Call Auction"
};
var FULL_CALL_AUCTION = [
    {
        label: "Input Order",
        inclusion: [
            true,
            false,
            false
        ]
    },
    {
        label: "Amend",
        inclusion: [
            true,
            false,
            false
        ]
    },
    {
        label: "Withdraw",
        inclusion: [
            true,
            false,
            true
        ]
    }, 
];
var EXISTING_CONTENT = {
    SESSION_A: SESSION_A_EXISTING,
    SESSION_B: SESSION_B_EXISTING,
    CRITERIA: CRITERIA,
    SPECIAL_INFO: SPECIAL_INFO_EXISTING,
    FULL_CALL_AUCTION: FULL_CALL_AUCTION
};
/* harmony default export */ var special_monitoring = ({
    SESSION_A: SESSION_A,
    SESSION_B: SESSION_B,
    CRITERIA: CRITERIA,
    SPECIAL_INFO: SPECIAL_INFO,
    FULL_CALL_AUCTION: FULL_CALL_AUCTION
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/securities/static/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  overflow: auto;\n\n  &::-webkit-scrollbar {\n    width: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StaticPageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2852a370-0"
})(_templateObject(), function(props) {
    return props.mode === "dark" ? "#121212" : color/* default.light */.Z.light;
});

// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
;// CONCATENATED MODULE: ./src/features/securities/static/information/specialMonitoring/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: 1px dashed;\n  border-color: ",
        ";\n  border-width: 1px 0 0;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  padding-bottom: 20px;\n  margin: 0 auto;\n  max-width: 500px;\n\n  @media screen and (max-width: 500px) {\n    margin: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid\n    ",
        ";\n  border-radius: 4px;\n  margin-top: 20px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 20px;\n  border-bottom: 1px solid\n    ",
        ";\n\n  h1 {\n    font-size: 14px;\n    font-family: var(--bold-font);\n    line-height: 19px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 20px;\n\n  .special-monitoring-session-container {\n    margin-top: 20px;\n\n    p {\n      margin-bottom: 8px;\n    }\n\n    .special-monitoring-session-item {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n\n  ul {\n    padding-inline-start: 24px;\n\n    li {\n      margin-bottom: 20px;\n\n      &::marker {\n        color: ",
        ";\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Divider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-30ff954e-0"
})(styled_templateObject(), function(props) {
    return props.mode === "dark" ? "rgb(238 238 238 / 25%)" : "rgb(238 238 238 / 95%)";
});
var SpecialMonitoringContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30ff954e-1"
})(_templateObject1());
var SpecialMonitoringCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30ff954e-2"
})(_templateObject2(), function(props) {
    return props.mode === "dark" ? "#2e2e2e" : color/* default.downgray */.Z.downgray;
});
var SpecialMonitoringHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30ff954e-3"
})(_templateObject3(), function(props) {
    return props.mode === "dark" ? "#2e2e2e" : color/* default.downgray */.Z.downgray;
});
var SpecialMonitoringBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30ff954e-4"
})(_templateObject4(), function(props) {
    return props.mode === "dark" ? color/* default.lowgray */.Z.lowgray : color/* default.highempahis */.Z.highempahis;
});

// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
;// CONCATENATED MODULE: ./src/features/securities/static/information/specialMonitoring/components/SessionItem.tsx




function SessionItem(param) {
    var session = param.session, idx = param.idx, color = param.color, _isExisting = param.isExisting, isExisting = _isExisting === void 0 ? false : _isExisting;
    var sessionContent = session;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justify: "space-between",
        width: "100%",
        // @ts-expect-error
        mt: "14px",
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                size: "12px",
                color: color,
                width: "40px",
                children: [
                    "Sesi ",
                    sessionContent.session
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        width: "98px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "12px",
                                color: "#858585",
                                mb: "4px",
                                children: "Order Collection"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "12px",
                                family: "bold",
                                color: color,
                                children: sessionContent.orderCollection
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                        condition: !isExisting,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                width: "98px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Random Closing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        family: "bold",
                                        color: color,
                                        children: sessionContent.randomClosing
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                width: "98px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Order Matching"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        family: "bold",
                                        color: color,
                                        children: sessionContent.orderMatching
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }, "".concat(sessionContent.session, "-").concat(idx + 1, "-session-a"));
};

;// CONCATENATED MODULE: ./src/features/securities/static/information/specialMonitoring/index.tsx










var SpecialMonitoringInformation = function(param) {
    var _mode = param.mode, mode = _mode === void 0 ? "light" : _mode;
    var CONTENT = special_monitoring;
    var textColor = (0,react.useMemo)(function() {
        return mode === "dark" ? color/* default.lowgray */.Z.lowgray : color/* default.highempahis */.Z.highempahis;
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticPageContainer, {
        mode: mode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringCard, {
                    mode: mode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringHeader, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                color: textColor,
                                children: "Kapan transaksi saya akan diproses?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringBody, {
                            mode: mode,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: textColor,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Order saat Full Call Auction"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justify: "space-between",
                                    width: "100%",
                                    mt: "12px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            color: textColor,
                                            width: "70px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            color: "#858585",
                                            width: "70px",
                                            align: "center",
                                            children: "Order Collection"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            color: "#858585",
                                            width: "70px",
                                            align: "center",
                                            children: "Random Closing"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            color: "#858585",
                                            width: "70px",
                                            align: "center",
                                            children: "Order Matching"
                                        })
                                    ]
                                }),
                                CONTENT.FULL_CALL_AUCTION.map(function(content, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justify: "space-between",
                                        width: "100%",
                                        // @ts-expect-error
                                        mt: "12px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "12px",
                                                color: textColor,
                                                width: "70px",
                                                family: "bold",
                                                children: content.label
                                            }),
                                            content.inclusion.map(function(inclusion) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                    align: "center",
                                                    justify: "center",
                                                    width: "70px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: inclusion ? "/icon/ic-check-green.svg" : "/icon/ic-close-red.svg"
                                                    })
                                                });
                                            })
                                        ]
                                    }, "".concat(content.label, "-").concat(idx + 1, "-fca"));
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                                    mode: mode,
                                    dashed: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    color: textColor,
                                    children: [
                                        "Transaksi kamu akan diproses pada masa",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "Order Matching"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    direction: "column",
                                    my: "20px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            color: textColor,
                                            children: "Senin-Kamis"
                                        }),
                                        CONTENT.SESSION_A.map(function(session, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionItem, {
                                                session: session,
                                                idx: idx,
                                                color: textColor
                                            }, "".concat(session.session, "-").concat(idx + 1, "-session-a"));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                                    mode: mode,
                                    dashed: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    direction: "column",
                                    my: "20px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            color: textColor,
                                            children: "Jumat"
                                        }),
                                        CONTENT.SESSION_B.map(function(session, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionItem, {
                                                session: session,
                                                idx: idx,
                                                color: textColor
                                            }, "".concat(session.session, "-").concat(idx + 1, "-session-b"));
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringCard, {
                    mode: mode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringHeader, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                color: textColor,
                                children: "Kenapa saya tidak bisa langsung beli saham ini?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringBody, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: textColor,
                                children: [
                                    "Per tanggal ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: CONTENT.SPECIAL_INFO.date
                                    }),
                                    ", Bursa Efek Indonesia menerapkan mekanisme",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: CONTENT.SPECIAL_INFO.auction
                                    }),
                                    " untuk saham di papan pemantauan khusus."
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringCard, {
                    mode: mode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringHeader, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                color: textColor,
                                children: "Apa kriteria saham dalam pemantauan khusus?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringBody, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: special_monitoring.CRITERIA.map(function(criteria, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: textColor,
                                            children: criteria.content
                                        })
                                    }, "".concat(criteria.id, "-").concat(idx + 1, "-criteria"));
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var specialMonitoring = (SpecialMonitoringInformation);


/***/ })

}]);